import styled, { css } from 'styled-components';
import Colors from 'library/constants/colors';
import { TransitionConfig } from '../constants/styles-config';
import { IconBase } from './icon';
import { ButtonMid } from './text';

export const ButtonBaseStyles = css`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  text-align: center;
  width: 100%;
  height: 48px;
  cursor: pointer;
  border: none;
  font-weight: bold;
  border-radius: 100px;
  box-sizing: border-box;
  
  :disabled {
    border-color: ${Colors.shade05};
    color: ${Colors.shade08};
    cursor: not-allowed;
    background-color: ${Colors.shade05} !important;
    opacity: 1;

    :before {
      opacity: 1;
      //background-color: inherit;
      background-color: ${Colors.shade05} !important;
    }
  }

  ${IconBase} {
    margin-top: -4px;
    transition: none;
  }
`;

export const ButtonStyles = css`
  ${ButtonBaseStyles};
  padding: 14px 20px;
  margin-top: 20px;
  overflow: hidden;
  font-size: 18px;
  line-height: 20px;
  background: linear-gradient(84.35deg, ${Colors.violet} 0%, ${Colors.blueLight} 100%);
  color: ${Colors.shade08};
  
  &:before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0;
    border-radius: 100px;
    background-color: ${Colors.violet};
    transition: opacity ${TransitionConfig};
  }
  
  span {
    position: relative;
  }

  &:hover {
    &:before {
      opacity: 1;
    }
  }
`;

export const ButtonSecondaryStyles = css`
  ${ButtonBaseStyles};
  margin-top: 20px;
  overflow: hidden;
  font-size: 18px;
  line-height: 20px;
  background-color: ${Colors.shade08};
  border: 2px solid ${Colors.violet};
  color: ${Colors.violet};
  transition: background-color ${TransitionConfig}, color ${TransitionConfig};

  &:hover {
    background-color: ${Colors.violet};
    color: ${Colors.shade08};
  }
`;

export const ButtonBack = styled.div`
  ${ButtonBaseStyles};
  ${ButtonMid};
  height: 40px;
  padding: 0 15px;
  background-color: ${Colors.shade08};
  transition: background-color ${TransitionConfig};
  
  i {
    margin-left: -14px;
    margin-right: -4px;
    color: ${Colors.violet};
  }

  &:hover {
    background-color: ${Colors.shade06};
  }
`;
